import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=f5f1f70e&scoped=true"
import script from "./forgot-password.vue?vue&type=script&lang=js"
export * from "./forgot-password.vue?vue&type=script&lang=js"
import style0 from "./forgot-password.vue?vue&type=style&index=0&id=f5f1f70e&lang=css"
import style1 from "./forgot-password.vue?vue&type=style&index=1&id=f5f1f70e&lang=scss&scoped=true"
import style2 from "./forgot-password.vue?vue&type=style&index=2&id=f5f1f70e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f1f70e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5f1f70e')) {
      api.createRecord('f5f1f70e', component.options)
    } else {
      api.reload('f5f1f70e', component.options)
    }
    module.hot.accept("./forgot-password.vue?vue&type=template&id=f5f1f70e&scoped=true", function () {
      api.rerender('f5f1f70e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/login/forgot-password.vue"
export default component.exports